import dashboardPortfolio from '@/components/dashboard/dashboard-portfolio/dashboard-portfolio.vue';

export default {
  components: {
    dashboardPortfolio,
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/page-portfolio/page-portfolio.js